<template>
    <div class="posts mb-3" v-if="posts && posts.length">
        <div class="posts__heading knowledge-base__heading d-flex">
            <img src="/assets/images/empty_header.svg" />

            <div class="posts__heading-title knowledge-base__heading-title">
                {{$store.getters.t('knowledge_posts_title')}}
            </div>
        </div>
        <div class="posts__content mt-3">
            <div class="container">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="bg-white posts-list">
                        <div class="post-item" v-for="post in posts">
                            <div class="post-item__category_logo">
                                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.69918 12.9417C1.55236 13.0577 1.52638 13.2417 1.57884 13.3875C1.63138 13.5335 1.76753 13.6526 1.95178 13.6273C3.24125 13.4499 4.45818 13.0942 5.60154 12.5602C6.44068 12.8287 7.33783 12.9682 8.25806 12.9682C12.2679 12.9682 15.5661 10.3122 15.5661 6.9591C15.5661 3.606 12.2679 0.95 8.25806 0.95C4.24822 0.95 0.95 3.606 0.95 6.9591C0.95 8.47497 1.63109 9.89396 2.82479 10.9829C2.79523 11.7156 2.43156 12.3626 1.69918 12.9417ZM5.68465 11.791C5.60278 11.7633 5.51448 11.7689 5.4363 11.8064C4.65123 12.1835 3.82847 12.471 2.96762 12.6691C3.35892 12.1068 3.54945 11.4788 3.5303 10.792C3.5272 10.6812 3.47953 10.5762 3.3982 10.5059C2.27878 9.53787 1.65484 8.28219 1.65484 6.9591C1.65484 4.09651 4.58384 1.71212 8.25806 1.71212C11.9323 1.71212 14.8613 4.09651 14.8613 6.9591C14.8613 9.82169 11.9323 12.2061 8.25806 12.2061C7.36191 12.2061 6.49143 12.0636 5.68465 11.791Z" fill="green" stroke="blue" stroke-width="0.1"/>
                                </svg>
                            </div>
                            <div class="row pb-2">
                                <div class="col-6">
                                    <a :href="'/blog/' + post.category.slug" class="post-item__category">{{post.category.name}}</a>
                                    <a :href="'/blog/' + post.category.slug + '/' + post.slug" class="post-item__title">{{post.title}}</a>
                                    <div class="post-item__meta">
                                        <div class="post-item__date">{{moment(post.publish_date).format(' MMM DD YYYY')}}</div>
                                        <div class="post-item__time">{{post.read_time}}</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <a :href="'/blog/' + post.category.slug + '/' + post.slug" class="post-item__image">
                                        <img v-if="post.main_image" :src="'/storage/' + post.main_image.path" alt="">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <div class="text-center">
                                <a href="/blog" class="posts-list__more">{{$store.getters.t('blog_navigation_view_all')}}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="post-categories" v-if="categories">
                        <template v-for="category in categories">
                            <a :href="'/blog/' + category.slug" class="post-categories-item p-4" :style="{background: getCategoryBackground(category)}">
                                <div class="post-categories-item__title">{{ category.name }}</div>
                                <div v-if="category.icon" class="post-categories-item__icon">
                                    <img :src="'/storage' + category.icon.path" alt="">
                                </div>
                            </a>
                        </template>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: "PostsMainPage",
    data() {
        return {
            moment: moment,
            categories: null,
            posts: null,
        }
    },
    mounted() {
        this.getDataForMainPreview();
    },
    methods: {
        getDataForMainPreview() {
            axios.get('/api/posts/previews').then(response => {
                this.categories = response.data.data.categories;
                this.posts = response.data.data.posts;
            });
        },

        getCategoryBackground(category) {
            var background = '#ee7372';

            if (category.bg_color) {
                background = category.bg_color;
            }

            if (category.main_image) {
                background = 'linear-gradient(90deg, rgba(46, 118, 228, 0.6) 0%, rgba(108, 77, 187, 0.6) 100%), url(/storage' + category.main_image.path + ')';
            }

            return background;
        }
    }
}
</script>

<style lang="scss" scoped>
.posts {
    background: #f0f1f5;
    padding-bottom: 50px;


    &-list {
        border-radius: 10px;
        padding: 28px 16px 24px 30px;
        width: 43%;

        @media (max-width: 1200px) {
            width: 100%;
        }

        & .post-item {
            padding: 8px 0 6px 27px;
            border: 0.7px solid #ececec;
            border-right: none;
            position: relative;
            border-top: none;

            &:first-child {
                border-top: 0.7px solid #ececec;
                padding: 15px 0 6px 27px;
            }

            &:first-child .post-item__category_logo {
                top: 19px;
            }

            &__category_logo {
                border-radius: 50%;
                background-color: #EAF1FC;
                width: 23px;
                height: 23px;
                position: absolute;
                top: 12px;
                left: -11px;
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    width: 9px;
                    height: 9px;
                }
            }

            &__category {
                color: #2E76E4;
                text-transform: uppercase;
                margin-top: 8px;
                font-size: 11.8px;
                line-height: 17px;
                display: block;
            }

            &__title {
                margin-top: 7px;
                font-size: 11.8px;
                line-height: 17px;
                color: #929292;
                display: block;
            }

            &__meta {
                display: flex;
                justify-content: space-between;
                color: #929292;
                margin-top: 11px;
                font-size: 9px;

                &__date {

                }

                &__read {
                    text-align: right;
                }
            }

            &__image {
                padding: 4px 5px;
                height: 94px;
                display: block;

                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    border-radius: 5px;
                }
            }

        }

        &__more {
            font-size: 17px;
            font-weight: bold;
        }
    }
}

.post-categories {
    display: flex;
    flex-wrap: wrap;
    margin-left: 15px;
    width: calc(57% - 15px);

    @media (max-width: 1200px) {
        width: 100%;
        margin-top: 15px;
        margin-left: 0;
    }


    &-item {
        height: 182px;
        border-radius: 7px;
        background-size: cover !important;
        background-position: center !important;
        position: relative;
        display: block;
        margin-bottom: 10px;

        @media (max-width: 1200px) {
            width: 100% !important;
        }


        & > div {
            transition: all 0.3s ease;
        }

        &:hover > div {
            transform: scale(1.1);
        }

        &__title {
            color: white;
            text-align: center;
            font-size: 20px;

        }

        &__icon {
            text-align: center;
            margin-top: 10px;

            img {
                max-height: 70px;
            }
        }

        @media (max-width: 1200px) {
            margin-right: 0 !important;
        }
    }

    & &-item:nth-child(1) {
        width: 65.4%;
        margin-right: 10px;
        font-size: 26px;

        .post-categories-item__title {
            font-size: 26px;
            margin-top: 15px;

            @media (max-width: 1200px) {
                font-size: 20px;
                margin-top: 25px;
            }
        }
    }

    & &-item:nth-child(1),
    & &-item:nth-child(2),
    & &-item:nth-child(4) {
        @media (max-width: 1200px) {
            align-items: center;
            justify-content: center;
        }
    }

    & &-item:nth-child(2) {
        width: calc(33.8% - 10px);

        .post-categories-item__title {
            font-size: 26px;
            margin-top: 15px;

            @media (max-width: 1200px) {
                font-size: 20px;
                margin-top: 25px;
            }
        }
    }

    & &-item:nth-child(3),
    & &-item:nth-child(4),
    & &-item:nth-child(5) {
        width: calc(33.8% - 10px);
        margin-right: 10px;
    }

    & &-item:nth-child(4) {
        .post-categories-item__title {
            margin-top: 15px;

            @media (max-width: 1200px) {
                margin-top: 25px;
            }
        }
    }

    & &-item:nth-child(3),
    & &-item:nth-child(5) {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        justify-content: center;
        flex-direction: column-reverse;

        @media (max-width: 1200px) {
            align-items: center;
            justify-content: center;
            font-size: 26px;
        }

        .post-categories-item__title {
            font-size: 20px;
            width: 100%;
        }
        .post-categories-item__icon {
            width: 100%;
        }
    }

    & &-item:nth-child(5) {
        margin-right: 0;
    }

    & &-item:nth-child(6) {
        width: 100%;
        margin-bottom: 0;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;

        @media (max-width: 1200px) {
            align-items: center;
            justify-content: center;
        }

        .post-categories-item__title {
            font-size: 20px;
            width: 100%;
            text-align: right;

            @media (max-width: 1200px) {
                text-align: center;
            }
        }
    }
}
</style>
